export default __webpack_public_path__ + "static/media/clear_24px_outlined.3afe2c5b.svg";